import React from "react";

export const scrollRefToTop = (elementRef: React.RefObject<HTMLDivElement>) => {
  if (elementRef.current) {
    elementRef.current.scrollIntoView();
  }
};
